// TEMPORARY FEATURE: drawn overlay images. See overlay-drawing-launcher.component.ts.

import type {CurveDrawingImageParameters} from "@cm/template-nodes"

// evaluated mattress mesh dimensions in cm
export type MattressSize = {width: number; length: number; height: number}

// drawing area of the plane an overlay image input belongs to, derived from the input's name or id
export function overlayFaceSizeCm(imageInput: string, size: MattressSize): {widthCm: number; heightCm: number} | undefined {
    const name = imageInput.toLowerCase()
    if (/top|bottom/.test(name)) return {widthCm: size.length, heightCm: size.width}
    if (/side/.test(name)) return {widthCm: size.length, heightCm: size.height}
    if (/head|foot/.test(name)) return {widthCm: size.width, heightCm: size.height}
    return undefined
}

// The mattress stretches the stored image when its face is resized, so the control points are stretched alike.
// widthCm / heightCm are the size the image was last rasterized at, which makes them the reference for the scale.
export function resizeCurveDrawing(parameters: CurveDrawingImageParameters, widthCm: number, heightCm: number): CurveDrawingImageParameters {
    const scaleX = widthCm / parameters.widthCm
    const scaleY = heightCm / parameters.heightCm
    return {
        ...parameters,
        widthCm,
        heightCm,
        strokes: parameters.strokes.map((stroke) => ({controlPoints: stroke.controlPoints.map(([x, y]) => [x * scaleX, y * scaleY])})),
    }
}

export function hexToRgb(hex: string): [number, number, number] {
    const value = parseInt(hex.slice(1), 16)
    return [((value >> 16) & 255) / 255, ((value >> 8) & 255) / 255, (value & 255) / 255]
}

export function rgbToHex(rgb: [number, number, number]): string {
    return `#${rgb
        .map((channel) =>
            Math.round(Math.min(1, Math.max(0, channel)) * 255)
                .toString(16)
                .padStart(2, "0"),
        )
        .join("")}`
}
